import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { firestorePlugin } from 'vuefire'
import store from './store'
Vue.use(firestorePlugin)

Vue.use(ElementUI);

Vue.config.productionTip = false

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
